<template>
  <div>
    <v-main>
      <ClassDiaryContainer />
    </v-main>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from "vue";

import ClassDiaryContainer from '@/container/records/ClassDiaryContainer.vue';

export default defineComponent({
  components: {
    ClassDiaryContainer,
  },
});
</script>
